import { forwardRef } from 'react'
import { Input } from '@dashboard/ui'
import { FieldGroup } from '@/ui'

interface FormTypeBorderRadiusControlProps {
  value: string
  onChange: (value: string) => void
}

export const FormTypeBorderRadiusControl = forwardRef<HTMLInputElement, FormTypeBorderRadiusControlProps>(function (
  { value, onChange },
  ref,
) {
  return (
    <div className="rounded-md border bg-fg-secondary">
      <div className="flex justify-between p-3">
        <div className="font-medium text-text-secondary">Border Radius</div>
      </div>

      <div className="border-t p-3">
        <div className="grid w-full grid-cols-4 gap-3">
          <FieldGroup label="Radius">
            <Input ref={ref} type="number" value={value} onChange={e => onChange(e.target.value)} />
          </FieldGroup>
        </div>
      </div>
    </div>
  )
})
